import{parse}from"qs";import forceCast from"./forceCast";var parseQuery=function(url){return forceCast(parse(url.slice(url.lastIndexOf("?")+1),{ignoreQueryPrefix:true}))};export default parseQuery;
//# sourceMappingURL=parseQuery.js.map